import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

import fetch from './fetch';
import dashboard from './dashboard';
import quickpay from './quickpay';

const quickpayPersistConfig = {
  key: 'quickpay',
  storage,
  whitelist: ['uid', 'lastPayment', 'scheduledAutopay'],
};

const rootReducer = combineReducers({
  dashboard,
  fetch,
  quickpay: persistReducer(quickpayPersistConfig, quickpay),
});

export default function createRootReducer() {
  return rootReducer;
}
